import React from 'react'

export const NoSSR: React.FC<React.ComponentProps<typeof React.Fragment>> = (props) => {
  const [mounted, setMounted] = React.useState(false)
  React.useEffect(() => setMounted(true), [])
  return mounted ? <React.Fragment {...props} /> : null
}
